import { render, staticRenderFns } from "./text-with-tag.vue?vue&type=template&id=d9620cbe&"
import script from "./text-with-tag.vue?vue&type=script&lang=js&"
export * from "./text-with-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9620cbe')) {
      api.createRecord('d9620cbe', component.options)
    } else {
      api.reload('d9620cbe', component.options)
    }
    module.hot.accept("./text-with-tag.vue?vue&type=template&id=d9620cbe&", function () {
      api.rerender('d9620cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/text-with-tag.vue"
export default component.exports